// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"618":"852bbd26489c0326","2888":"1db982d69bcebd96","7168":"b5429893e4eb7820"}[chunkId] + ".css";
};